import { Box, Grid, Typography, Paper } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { useState, useEffect, ChangeEvent } from 'react';

const useStyles = makeStyles((theme: Theme) => 
  createStyles({
    formContainer: { 
      padding: theme.spacing(2)
    },
    paper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3)
    },
    mainTitle: {
      marginBottom: theme.spacing(3),
      fontWeight: 500
    },
    sectionTitle: {
      marginBottom: theme.spacing(2),
      fontWeight: 500
    },
    charCount: {
      textAlign: 'right',
      fontSize: '0.75rem',
      color: theme.palette.text.secondary,
      marginTop: theme.spacing(0.5)
    }
  })
);

interface FormData {
  dataArmazenamentoInicio: string;
  temperaturaRecolha: string;
  descricaoRazao: string;
  observacoes: string;
}

export default function InformacoesAdicionais() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState<FormData>({
    dataArmazenamentoInicio: '',
    temperaturaRecolha: '',
    descricaoRazao: '',
    observacoes: ''
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  useEffect(() => {
    dispatch({
      type: 'dadosAdicionais',
      payload: { dadosAdicionais: formData }
    });
  }, [formData, dispatch]);

  return (
    <Box className={classes.formContainer}>
      <Typography variant="h5" className={classes.mainTitle}>
        INFORMAÇÕES ADICIONAIS
      </Typography>

      {/* Primeira seção: Duração e condição de armazenamento */}
      <Paper className={classes.paper} elevation={2}>
        <Typography variant="h6" className={classes.sectionTitle}>
          Duração e condição de armazenamento:
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              type="date"
              label="Em stock desde a data de"
              fullWidth
              size="small"
              name="dataArmazenamentoInicio"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              onChange={handleChange}
              value={formData.dataArmazenamentoInicio}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              type="text"
              label="Temperatura no momento da recolha"
              fullWidth
              size="small"
              name="temperaturaRecolha"
              variant="outlined"
              onChange={handleChange}
              value={formData.temperaturaRecolha}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Segunda seção: Descrição da razão do controlo de qualidade */}
      <Paper className={classes.paper} elevation={2}>
        <Typography variant="h6" className={classes.sectionTitle}>
          Descrição da razão do controlo de qualidade
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              multiline
              rows={4}
              type="text"
              label="Descrição da razão do controlo de qualidade, das condições de armazenamento e de transporte do produto e descrição das embalagens"
              placeholder="Descreva detalhadamente..."
              fullWidth
              name="descricaoRazao"
              variant="outlined"
              onChange={handleChange}
              value={formData.descricaoRazao}
            />
            <Typography className={classes.charCount}>
              {formData.descricaoRazao.length} caracteres
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      {/* Terceira seção: Observações */}
      <Paper className={classes.paper} elevation={2}>
        <Typography variant="h6" className={classes.sectionTitle}>
          Observações
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              multiline
              rows={3}
              type="text"
              label="Outras observações"
              fullWidth
              name="observacoes"
              variant="outlined"
              onChange={handleChange}
              value={formData.observacoes}
            />
            <Typography className={classes.charCount}>
              {formData.observacoes.length} caracteres
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}